import * as React from 'react';
import { IgcPaginatorComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcPaginatorComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Paginator component description
 * @fires perPageChange - Emitted when `perPage` property value of the paginator is changed.
 * @fires pageChange - Emitted after the current page is changed.
 * @fires paging - Emitted before paging is performed.
 * @fires pagingDone - Emitted after paging is performed.
 * @class
 */
export const IgrPaginator = /* @__PURE__ */ createComponent({
  tagName: 'igc-paginator',
  displayName: 'IgrPaginator',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onPerPageChange: 'perPageChange' as EventName<
      IgcPaginatorComponentEventMap['perPageChange']
    >,
    onPageChange: 'pageChange' as EventName<
      IgcPaginatorComponentEventMap['pageChange']
    >,
    onPaging: 'paging' as EventName<IgcPaginatorComponentEventMap['paging']>,
    onPagingDone: 'pagingDone' as EventName<
      IgcPaginatorComponentEventMap['pagingDone']
    >,
  },
});

export type IgrPaginator = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrPaginatorModule = Component;
